import { createContext } from 'react'

export type IndexPageContextType = {
  model: string | null
  resourceId: any | null
  resource: { id: any } | null
  action: CrudAction | null
}

const IndexPageContext = createContext<IndexPageContextType>(undefined as any)

export default IndexPageContext
